"use client";
import React, { FC, useState } from "react";
import { useAppDispatch, useAppSelector } from '@/app/lib/hooks';
import { uploadFile } from '@/app/lib/reducers/recruitmentReducer';
import { RootState } from '@/app/lib/store';
import { useTranslation } from "react-i18next";

export interface Recruitment5Props {}

const Recruitment5: FC<Recruitment5Props> = () => {
  const dispatch = useAppDispatch();
  const uploadedImageUrl = useAppSelector((state: RootState) => state.recruitment.uploadedImageUrl);
  const u = useAppSelector((state: RootState) => state.auth.user);
  const [isUploading, setIsUploading] = useState(false);
  const { t } = useTranslation("guydeez");

  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const imageFile = event.target.files?.[0];
    if (imageFile) {
      const formData = new FormData();
      formData.append('file', imageFile);
      formData.append('bucket', "guydeez--users");
      formData.append('path', `${u?.uuid || ""}/`);
      formData.append('uuid', u?.uuid || "");

      setIsUploading(true);

      dispatch(uploadFile(formData))
        .then(() => {
          setIsUploading(false);
        })
        .catch(() => {
          setIsUploading(false);
        });
    }
  };

  return (
    <>
      <div>
        <h2 style={{ fontSize: 20, fontWeight: 800, color: "var(--g-burgundy)", lineHeight: 1.2 }}>
          {t('recruitment_upload_your_picture_title')}
        </h2>
        <span className="block mt-2" style={{ fontSize: 13, color: "var(--g-ink-500)" }}>
          {t('recruitment_upload_your_picture_subtitle')}
        </span>
      </div>

      <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
      <div className="space-y-8">
        <div>
          <span style={{ fontSize: 14, fontWeight: 700, color: "var(--g-burgundy)" }}>{t('recruitment_picture_of_yourself')}</span>
          <div className="mt-5">
            <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-neutral-300 dark:border-neutral-600 border-dashed rounded-md">
              <div className="space-y-1 text-center">
                {isUploading ? (
                  <div className="text-center">
                    <p className="text-neutral-600 dark:text-neutral-300">{t('recruitment_uploading')}</p>
                  </div>
                ) : (
                  <>
                    {uploadedImageUrl && (
                      <>
                        <img src={uploadedImageUrl} alt="Uploaded" className="mx-auto h-72" />
                        <p className="text-xs text-neutral-500 dark:text-neutral-400">
                          {t('recruitment_current_image')}
                        </p>
                      </>
                    )}
                    <svg
                      className="mx-auto h-12 w-12 text-neutral-400"
                      stroke="currentColor"
                      fill="none"
                      viewBox="0 0 48 48"
                      aria-hidden="true"
                    >
                      {/* Your SVG path here */}
                    </svg>
                    <div className=" text-sm text-neutral-600 dark:text-neutral-300">
                      <label
                        htmlFor="file-upload"
                        className="relative cursor-pointer rounded-md font-medium text-primary-600 hover:text-primary-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500"
                      >
                        <span className="mx-auto">{t('recruitment_upload_file')}</span>
                        <input
                          id="file-upload"
                          name="file-upload"
                          type="file"
                          className="sr-only"
                          accept="image/*"
                          onChange={handleImageUpload}
                        />
                      </label>
                    </div>
                    <p className="text-xs text-neutral-500 dark:text-neutral-400">
                      {t('recruitment_file_expectation')}
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* Tip — a pro photo gets more requests */}
          <div
            className="flex items-start"
            style={{
              gap: 10,
              marginTop: 16,
              padding: 12,
              borderRadius: 10,
              background: "rgba(31,138,91,.06)",
              border: "1px solid rgba(31,138,91,.2)",
            }}
          >
            <span
              className="grid place-items-center"
              style={{
                width: 26,
                height: 26,
                borderRadius: 7,
                background: "var(--g-green-deep, #2E8C4D)",
                flexShrink: 0,
              }}
              aria-hidden="true"
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
            </span>
            <div style={{ fontSize: 12, color: "var(--g-ink-700, #4a4a4a)", lineHeight: 1.5 }}>
              <strong style={{ color: "var(--g-burgundy)" }}>
                {t("recruitment_photo_tip_label", { defaultValue: "Conseil :" })}
              </strong>{" "}
              {t("recruitment_photo_tip", {
                defaultValue:
                  "photo pro = 3× plus de demandes. Sourire, lumière naturelle.",
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Recruitment5;
